angular.module('rjmNg.directives').directive "manageReports", [
  () ->
    restrict: "E"
    templateUrl: "directive.manageReports.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope: {}
    controller: [
      "$q"
      "$routeParams"
      "$timeout"
      "appRoute"
      "Charts"
      "CONNECTIONS"
      "ConnectionMeta"
      "errorConstants"
      "figureService"
      "logger"
      "Metrics"
      "notification"
      "Figures"
      "dependencyEnums"
      (
        $q
        $routeParams
        $timeout
        appRoute
        Charts
        CONNECTIONS
        ConnectionMeta
        errorConstants
        figureService
        logger
        Metrics
        notification
        Figures
        dependencyEnums
      ) ->

        _reports = []
        _metrics = []
        _gaConnections = []
        _taStates = 
          all: 'rj-icon rj-icon--check-square-o'
          some: 'rj-icon rj-icon--minus-square-o'
          none: 'rj-icon rj-icon--square-o'

        notificationTimeout = 15
        
        view = @
        view.clientId = $routeParams.clientId

        view.deleteEnabled = false
        view.showOnlyUnused = false
        view.taState = _taStates.none
        view.metrics = []
        view.reports = []
        view.filteredReports = []
        view.selectedMetrics = []
        view.loading = true

        view.dependencyPromises = {}
        view.showDependencyResolver = false
        view.depResourceType = dependencyEnums.RESOURCE_TYPES.FIGURE
        view.depResourceNames = {}
        view.depConfirmMsg = 'Delete these reports?'

        _init = ->
          # reset variables if needed
          view.deleteEnabled = false
          view.showOnlyUnused = false
          view.selectedMetrics = []
          view.taState = _taStates.none

          # get data
          $q.all([
            Metrics.get(view.clientId)
            Figures.getAllFigures()
            ConnectionMeta(view.clientId).gaConnections()
          ]).then ([metrics, figures, gaconnections]) ->
            # aggregate ga and metrics together
            _gaConnections = gaconnections.map((gaMet) -> 
              newMet = {}
              newMet.meta_id = gaMet.id
              newMet.name = gaMet.meta.name
              newMet
            )
            _metrics = metrics.concat(_gaConnections)
            # configure report list
            _reports = figures.map((report) ->
              report.usage = report.dashboard_items.length isnt 0
              report.isSelected = false
              report.metricIds = []

              if (report.query_type is 'rjql') 
                report.editUrl = appRoute("/reports/"+report.id)
                report.metricIds = figureService.getMetricIdsFromFigure(report)
              else if (report.query_type is 'sql')
                report.editUrl = appRoute("/reports/sql/"+report.id)

              report
            )
            view.metrics = _metrics
            view.reports = _reports
            
            view.loading = false        
          , (error) ->
            view.loading = false      
            notification.error("Server Error",
              errorConstants.SERVER_ERROR_MESSAGE,
              "reports",
              null,
              notificationTimeout
            )

        _changeToSelectedReports = () ->
          if(_reportsToDelete().length > 0)
            view.deleteEnabled = true
            if(_reportsToDelete().length is view.filteredReports.length)
              view.taState = _taStates.all
            else
              view.taState = _taStates.some
          else
            view.deleteEnabled = false
            view.taState = _taStates.none

        _enableDelete = () ->
          if(_reportsToDelete().length > 0)
            view.deleteEnabled = true

        _filterReportsByMetrics = () ->
          if(view.selectedMetrics.length > 0)
            view.reports = view.reports.filter((report) -> 
              hasMetric = false
              for met in report.metricIds
                if(Array.isArray(met))
                  hasMetric = _.find(view.selectedMetrics, (m) -> m.meta_id is met[0])
                else
                  hasMetric = _.find(view.selectedMetrics, (m) -> 
                    return m.id is met and m.meta_id is undefined
                  )
                if(hasMetric)
                  return hasMetric
            )
        
        _filterOnlyUnused = () ->
          if(view.showOnlyUnused)
            view.reports = _reports.filter((report) -> !report.usage)
          else
            view.reports = _reports

        #use this one whenever applying filters
        _filterReports = () ->
          _filterOnlyUnused()
          _filterReportsByMetrics()
          $timeout(_unselectHiddenReports, 0)

        _removeMetric = (metricList, metric) ->
          metricList.filter((m) -> 
            if(m.meta_id || metric.meta_id)
              return metric.meta_id isnt m.meta_id
            else
              return m.id isnt metric.id 
          )

        _reportsToDelete = () -> 
          view.filteredReports.filter((rep) -> rep.isSelected)

        _unselectHiddenReports = () ->
          reportsToDeselect = _.difference(_reports, view.filteredReports)
          for report in reportsToDeselect
            report.isSelected = false
          $timeout(_changeToSelectedReports, 0)

        view.addMetric = (metric, evt) ->
          evt.preventDefault() #prevents clicking next item when array changes
          view.selectedMetrics.push(metric)
          view.metrics = _removeMetric(view.metrics, metric)
          _filterReports()
        
        view.confirmDeleteCallback = (choices) ->
          view.loading = true       
          deletePromises = []
          for id,value of choices when value.selected
            deletePromises.push Figures.delete(id)
          $q.all(deletePromises).then(
            (response) ->
              #view.loading will be handled in _init()
              _init()
            , (error) ->
              view.loading = false
              notification.error("Server Error",
                errorConstants.SERVER_ERROR_MESSAGE,
                "reports",
                null,
                notificationTimeout
              )
          )

        view.deleteReports = () ->
          reportsToDelete = _reportsToDelete()
          if(reportsToDelete.length > 0)
            view.dependencyPromises = reportsToDelete.reduce((accu, rep) -> 
                if(!accu[rep.id])
                  accu[rep.id] = Figures.dependents(rep.id)
                return accu
              , {})
            
            view.depResourceNames = reportsToDelete.reduce((accu, rep) -> 
                if(!accu[rep.id])
                  accu[rep.id] = 
                    name: rep.name
                return accu
              , {})

            view.showDependencyResolver = true;

        view.filterOnlyUnused = (filterSetting) ->
          view.showOnlyUnused = filterSetting
          _filterReports()

        view.removeMetric = (metric, evt) ->
          evt.preventDefault() #prevents clicking next item when array changes    
          view.metrics.push(metric)
          view.selectedMetrics = _removeMetric(view.selectedMetrics, metric)
          _filterReports()

        view.toggleAllReports = () ->
          allReportsState = true
          if(view.taState is _taStates.all)
            allReportsState = false

          for report in view.filteredReports
            report.isSelected = allReportsState
          
          _changeToSelectedReports() 

        view.toggleReport = () ->         
          _changeToSelectedReports()

        view.unselectHiddenReports = () ->
          _unselectHiddenReports()

        @$postLink = () ->
          _init()
          # Send this to the journal
          logger.log('Reports Page Usage', 'Open', 1, 'list')

        return view
    ]
]